import logo from 'assets/images/unlock.png';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => <img src={logo} alt="unlock" width="60" />;
export default Logo;
